// src/belediye/components/mesajlasma/mesajlasmaSound.js
//
// Kurum İçi Mesajlaşma — GLOBAL ses tercihi (TEK anahtar, tüm sohbetler için).
// Mesaj gidişinde/gelişinde kısa ses çalar; başlık menüsündeki (katılımcılar +
// "Sohbeti sil" paneli) anahtarla kapatılır. Kapalıyken HİÇBİR sohbet ses
// çıkarmaz. Kalıcılık: localStorage (frontend-only, backend değişikliği YOK).
//
// Genel bildirim sesinden (NotificationToaster / preferences.sound_enabled)
// BAĞIMSIZ — bu anahtar yalnız mesajlaşma seslerini yönetir. Ses sentezi ve
// autoplay kilidi notificationSound ile paylaşılır (tek AudioContext).

import { useEffect, useState } from "react";

import {
  playMessageReceivedSound,
  playMessageSentSound,
} from "../notifications/notificationSound";

const KEY = "msjSoundMuted";
export const MSJ_SOUND_EVENT = "mesajlasma:sound-pref";

// Varsayılan: AÇIK (ses var). "1" → kapalı (sessiz).
export const isMsjSoundMuted = () => {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

// Tercihi yaz + tüm dinleyicilere (dock/thread/diğer sekme) yay.
export const setMsjSoundMuted = (muted) => {
  try {
    localStorage.setItem(KEY, muted ? "1" : "0");
  } catch {
    /* yut */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(MSJ_SOUND_EVENT, { detail: { muted: !!muted } }));
  }
};

// Anahtarı okuyan + yazan hook. Değişiklik her yerde anında yansısın diye
// CustomEvent'e (aynı sekme) ve storage olayına (diğer sekme) abone olur.
// Dönüş: [muted, setMsjSoundMuted] — [durum, değiştirici].
export function useMsjSoundMuted() {
  const [muted, setMuted] = useState(isMsjSoundMuted);
  useEffect(() => {
    const onPref = (e) => setMuted(!!e?.detail?.muted);
    const onStorage = (e) => {
      if (e.key === KEY) setMuted(e.newValue === "1");
    };
    window.addEventListener(MSJ_SOUND_EVENT, onPref);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(MSJ_SOUND_EVENT, onPref);
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return [muted, setMsjSoundMuted];
}

// Kapılı çalıcılar — anahtar kapalıysa hiç ses yok (tüm sohbetlerde geçerli).
export const playMsjSent = () => {
  if (!isMsjSoundMuted()) playMessageSentSound();
};
export const playMsjReceived = () => {
  if (!isMsjSoundMuted()) playMessageReceivedSound();
};
